import React from 'react'
import styled from 'styled-components'

import HeroText from 'components/heroText'
import HeroFooter from 'components/heroFooter'
import { Background } from 'components/common'

const HeroContainer = styled.div`
  width: 100%;
  height: 100vh;
  padding-top: 5.5rem;
  padding-bottom: 5.5rem;
  position: relative;
  min-height: 750px;
`

const Hero = ({ bg }) => (
  <HeroContainer id="home">
    <Background fluid={bg} />
    <HeroText />
    <HeroFooter />
  </HeroContainer>
)

export default Hero
